import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { Tab, TabPane } from 'semantic-ui-react'
import Emails from './Emails'
import SMSLogs from './SMSLogs'
import ActivityLogs from './ActivityLogs'

const Protocols: React.FC = () => {
  const { t } = useTranslation()

  const [activeIndex, setActiveIndex] = useState(0)

  function renderProtocols() {
    const panes = [
      {
        menuItem: t('Email protocole'),
        component: <Emails />
      },
      {
        menuItem: t('Sms protocole'),
        component: <SMSLogs />
      },
      {
        menuItem: t('Activity protocols'),
        component: <ActivityLogs />
      }
    ]
    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeIndex}
      renderActiveOnly={false}
      onTabChange={(e, data) => setActiveIndex(data.activeIndex as number)}
      panes={panes.map((pane, index) => {
        return {
          menuItem: pane.menuItem,
          pane: <TabPane
            active={index === activeIndex}
            style={{ border: 'none', marginBottom: 0, borderRadius: 15, minHeight: 400, background: 'transparent' }}
            key={pane.menuItem}
          >
            {pane.component}
          </TabPane>
        }
      })}
    />
  }

  return <Layout
    title={''}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    useSpinner
  >
    {renderProtocols()}
  </Layout>
}
export default Protocols